var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_633",
    "data-name": "\\uADF8\\uB8F9 633",
    transform: "translate(-1333 -919)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_31",
    "data-name": "\\uD0C0\\uC6D0 31",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1333 919)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "code",
    d: "M5.719,14.75a1,1,0,0,1-.664-.252L0,10,5.336,5.252a1,1,0,1,1,1.328,1.5L3.005,10l3.378,3a1,1,0,0,1-.664,1.748Zm8.945,0L20,10l-5.06-4.5A1,1,0,0,0,13.617,7L17,10l-3.659,3.252a1,1,0,0,0,1.328,1.5ZM9.986,16.165l2-12a1,1,0,1,0-1.972-.329l-2,12a1,1,0,1,0,1.972.329Z",
    transform: "translate(1340 926)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.7b15b23e943ee0924df01ab8260293d1.svg";
export { ForwardRef as ReactComponent };